import { mainApi } from '@/lib/api';
import { StoreData } from '@/types/store';

export async function updateStoreData(storeId: number, data: StoreData): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}`, data);
}
